export default "__VITE_ASSET__C8jR7rSj__"